const DEFAULT_COLOR = '#1198CF';
const DEFAULT_ICON = 'mdi-help-circle-outline';

import ContentType from '@/helpers/contentType';

export default {
  methods: {
    getIcon(type) {
      const getterTopicTypesIcons = this.$store.getters['plataforma/institutionConfiguration/getterTopicTypesIcons'];

      if (!getterTopicTypesIcons || !Object.keys(getterTopicTypesIcons).length) {
        ContentType.logMiddlewareError('Topic types icons not loaded, returning default icon', 'getIcon');
      }

      return getterTopicTypesIcons[type] || DEFAULT_ICON;
    },
    getColor(type) {
      const getterTopicTypesColors = this.$store.getters['plataforma/institutionConfiguration/getterTopicTypesColors'];

      if (!getterTopicTypesColors || !Object.keys(getterTopicTypesColors).length) {
        ContentType.logMiddlewareError('Topic types colors not loaded, returning default color', 'getColor');
      }

      return getterTopicTypesColors[type] || DEFAULT_COLOR;
    }
  }
};
